import { render, staticRenderFns } from "./AddCouponGroupModal.vue?vue&type=template&id=2f6b12a5"
import script from "./AddCouponGroupModal.vue?vue&type=script&lang=js"
export * from "./AddCouponGroupModal.vue?vue&type=script&lang=js"
import style0 from "./AddCouponGroupModal.vue?vue&type=style&index=0&id=2f6b12a5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports